import translate from '@translate';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { TaskType } from 'src/types/tasksGrid';

export const formatOrders = (data: any[]) => {
    return data.map((item) => {
        let extendData: any = {};
        switch (item.STATUS) {
            case 'incorrect':
                extendData.CREATED_AT = item.INCORRECT_AT;
                break;
            case 'productsNotAvailable':
                extendData.CREATED_AT = item.TIMESTAMP;
                break;
            default:
                break;
        }
        return {
            ID_ITEM: item.ID,
            SECTION: 'ORDER',
            STATUS: item.STATUS,
            type: 'state',
            TEXT: `ORDER.UPDATE_STATUS.${(item.STATUS || '').toUpperCase()}`,
            ID: `ORDER-${item.ID}-${extendData.CREATED_AT}`,
            itemData: item,
            ...extendData,
        };
    });
};

export const formatReceivings = (data: any[]) => {
    return data.map((item) => {
        let extendData: any = {};
        switch (item.STATUS) {
            case 'awaiting':
                extendData.CREATED_AT = item.ESTIMATED_DELIVERY;
                extendData.TEXT = 'RECEIVING.NOTDELIVEREDATTIME';
                break;
            default:
                break;
        }
        return {
            ID_ITEM: item.ID,
            SECTION: 'RECEIVING',
            STATUS: item.STATUS,
            type: 'state',
            ID: `RECEIVING-${item.ID}-${extendData.CREATED_AT}`,
            itemData: item,
            ...extendData,
        };
    });
};

export const formatTasks = (data: any[]) => {
    return data.map((item) => {
        let extendData: any = {};
        let itemData = JSON.parse(item.JSON_DATA);
        switch (item.TEXT) {
            case 'CLAIM.UPDATE_STATUS':
                extendData.TEXT = `${item.TEXT}.${(item.STATUS || '').toUpperCase()}`;
                extendData.ID_ITEM = itemData.ID;
                break;
            case 'RECEIVING.DIFFERENCE_PRODUCTS':
                extendData.TEXT = `${item.TEXT}`;
                extendData.ID_ITEM = itemData.ID;
                break;
            default:
                break;
        }
        extendData.itemData = itemData;
        return { ...item, ...extendData, type: 'notification' };
    });
};

export const transalteTexts = (items: any[]) =>
    items.map((item) => ({ ...item, transaltedText: translate(`tasks.text.${item.TEXT}`, item.itemData) }));
export const formatData = (
    items: any[],
    orderStatusCodesObject: ConstantsCodesObjectType,
    receivingStatusCodesObject: ConstantsCodesObjectType,
    claimStatusCodesObject: ConstantsCodesObjectType
) =>
    items.map((item) => {
        let out: TaskType = { ...item, transaltedText: translate(`tasks.text.${item.TEXT}`, item.itemData) };
        if (item.CREATED_AT) {
            out.WAITING_DAYS = Math.floor(
                (new Date().getTime() - new Date(item.CREATED_AT).getTime()) / (1000 * 3600 * 24)
            );
        }

        if (out.WAITING_DAYS < 0) {
            out.WAITING_DAYS = 0;
        }

        switch (item.SECTION) {
            case 'ORDER':
                out.statusText = orderStatusCodesObject[item.STATUS]?.label;
                out.statusColor = orderStatusCodesObject[item.STATUS]?.color;
                break;
            case 'RECEIVING':
                out.statusText = receivingStatusCodesObject[item.STATUS]?.label;
                out.statusColor = receivingStatusCodesObject[item.STATUS]?.color;
                break;
            case 'CLAIM':
                out.statusText = claimStatusCodesObject[item.STATUS]?.label;
                out.statusColor = claimStatusCodesObject[item.STATUS]?.color;
                break;
        }

        return out;
    });
